import React from 'react';

import { useSelector } from 'react-redux';

import { productsListSelector } from 'selectors';
import { Product } from 'types/IProducts';
import { Box } from 'UIKit';

import { RecentSearchProps } from './interface';
import styles from '../universal-search.module.scss';

const RecentSearches = ({ recentSearches, onRowClick }: RecentSearchProps) => {
  const productsList = useSelector(productsListSelector);

  const onRecentSearchItemClick = productSymbol => {
    const product = productsList.find(item => item.symbol === productSymbol);
    onRowClick(product as Product, true);
  };

  return (
    <Box
      renderWhen={recentSearches.length > 0}
      className={styles.recentSearchesContainer}
    >
      <Box className={styles.heading}>Recent Searches</Box>
      <Box className={styles.recentSearchProducts}>
        {recentSearches.map(searchItem => {
          return (
            <Box
              key={searchItem}
              data-testid={`recent-search-item-${searchItem}`}
              className={styles.recentSearchItem}
              onClick={() => onRecentSearchItemClick(searchItem)}
            >
              {searchItem}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default RecentSearches;
